import { type HighlightType, type HighlightedCell, useActiveGridHighlight } from "@/grid/GridCellHighlightProvider";
import { useEffect, useMemo } from "react";

type Params = {
  active: boolean;
  type?: HighlightType;
  id?: number;
};

export function usePinnedGridHighlight({ active, type, id }: Params) {
  const { pinned, setPinnedHighlighted } = useActiveGridHighlight();

  const cell = useMemo<HighlightedCell | undefined>(() => {
    if (type === undefined || id === undefined) {
      return undefined;
    }
    return { type, id };
  }, [id, type]);

  useEffect(() => {
    if (!cell) {
      return;
    }

    const isPinned = pinned?.type === cell.type && pinned?.id === cell.id;

    if (active && !isPinned) {
      setPinnedHighlighted(cell);
      return;
    }

    if (!active && isPinned) {
      setPinnedHighlighted(undefined);
    }
  }, [active, cell, pinned?.id, pinned?.type, setPinnedHighlighted]);

  useEffect(() => {
    if (!cell) {
      return;
    }
    return () => {
      const isPinned = pinned?.type === cell.type && pinned?.id === cell.id;
      if (isPinned) {
        setPinnedHighlighted(undefined);
      }
    };
  }, [cell, pinned?.id, pinned?.type, setPinnedHighlighted]);
}
